import { combineReducers } from 'redux';
import { createActions, createConsts } from '../../utils/redux';
import loggedUser from './loggedUser';
import teamUser from './team-user';
import targetUser from './targetUser';
import permissions from './permissions';

export const consts = createConsts(
  'context',
  'targetUser',
  'SET_TARGET_USER_ID',
  'CLEAR',
);
export const actions = createActions(consts);

export const isDefaultBehavior = payload =>
  Number.isInteger(payload) || payload === null;

const targetUserId = (state = null, action) => {
  const { type } = action;

  switch (type) {
    case consts.SET_TARGET_USER_ID:
      return isDefaultBehavior(action.payload)
        ? action.payload
        : action.payload.id;
    case consts.CLEAR:
      return null;
    default:
      return state;
  }
};

export default combineReducers({
  loggedUser,
  teamUser,
  targetUser,
  permissions,
  targetUserId,
});



// WEBPACK FOOTER //
// ./src/redux/context/index.js